import { useState, useEffect } from "react";

import { useNavigate } from "react-router";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
import MDButton from "components/MDButton";
// @mui material components
import Grid from "@mui/material/Grid";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
 import { CircularProgress } from "@mui/material";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
} from "@mui/material";
import { IconButton } from "@mui/material";
import { Cancel as CancelIcon } from "@mui/icons-material";
import { orange } from "@mui/material/colors";
import { getHobbyData } from "../../redux/slices/hobbyDataSlice";
import { HandleRows } from "./Rows";
import { addCategory } from "services/apis";

function HobbyTable() {
  const dispatch = useDispatch();

  // const [loading, setLoading] = useState(true);
  const { hobbyData, error, loading } = useSelector((state) => state.hobbyData);
  const [buttonLoading, setButtonLoading] = useState(false);

  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({
    categoryTitle: "",
  });

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    console.log(formData);
    setFormData({
      categoryTitle: "",
    });
    setOpen(false);
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.id]: e.target.value,
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setButtonLoading(true);

    try {
      const response = await addCategory(formData);
      console.log("response", response);

      if (response.success) {
        Swal.fire({
          icon: "success",
          title: "Category Added",
          timer: 1500,
          showConfirmButton: false,
        }).then(() => {
          dispatch(getHobbyData());
          setFormData({
            categoryTitle: "",
          });
        });
      }
    } catch (e) {
      Swal.fire({
        icon: "error",
        title: "Error Occurred",
      });
    } finally {
      setButtonLoading(false);
      handleClose();
    }
  };


  const handleApiCall = async () => {
    try {
      dispatch(getHobbyData());
    } catch (e) {
      console.log("e: ", e);
    }

  };

  useEffect(() => {
    handleApiCall();
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            {!loading ? (
              <MDBox>
                <MDBox
                  mx={2}
                  mt={-3}
                  py={3}
                  px={2}
                  variant="gradient"
                  bgColor="light"
                  borderRadius="lg"
                  coloredShadow="light"
                  sx={{
                    display: "flex",
                    flexDirection: { xs: "column", sm: "row" },
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: 2,
                    p: 3,
                  }}
                >
                  <MDBox>
                    <MDTypography variant="h5" color="white">
                      Hobby Categories
                    </MDTypography>
                  </MDBox>
                  <MDTypography>
                    <MDButton
                      variant="contained"
                      size="small"
                      sx={{
                        color: "black",
                        marginLeft: { xs: 0, md: "12px" },
                        marginRight: { xs: 0, md: "12px" },
                        color: "black",
                        paddingBottom: "13px",
                        paddingTop: "13px",
                        width: { xs: "100%", md: "auto" },
                      }}
                      fullWidth
                      onClick={handleOpen}
                    >
                      Add Category
                    </MDButton>
                  </MDTypography>
                  {/* Add hobby */}
                  <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
                    <DialogTitle>
                      Add Category
                      <span
                        style={{
                          position: "absolute",
                          top: 0,
                          right: 0,
                          padding: "10px",
                          cursor: "pointer",
                        }}
                      >
                        <IconButton onClick={handleClose}>
                          <CancelIcon sx={{ color: orange[500] }} />
                        </IconButton>
                      </span>
                    </DialogTitle>
                    <DialogContent style={{ overflowX: "hidden" }}>
                      <form onSubmit={handleSubmit}>
                        <TextField
                          autoFocus
                          margin="dense"
                          id="categoryTitle"
                          name="categoryTitle"
                          label="Category Title "
                          type="text"
                          required
                          fullWidth
                          value={formData.categoryTitle}
                          onChange={handleChange}
                        />

                        <MDButton
                          type="submit"
                          variant="gradient"
                          color="light"
                          sx={{
                            marginRight: "12px",
                            marginTop: "10px",
                          }}
                          fullWidth
                          disabled={!formData.categoryTitle || formData.categoryTitle.trim() === ""}
                        >
                          {buttonLoading ? (
                            <MDBox
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              width="100%"
                            >
                              <CircularProgress sx={{ color: "#ffffff" }} size={24} />
                            </MDBox>
                          ) : (
                            <MDTypography
                              style={{ fontSize: "13.5px", fontWeight: "bold" }}
                              color="white"
                            >
                              Submit
                            </MDTypography>
                          )}
                        </MDButton>
                      </form>
                    </DialogContent>
                  </Dialog>
                </MDBox>
                <MDBox pt={3}>{!loading && hobbyData?.length > 0 && <HandleRows />}</MDBox>
              </MDBox>
            ) : error ? (
              <MDBox
                display="flex"
                justifyContent="center"
                alignItems="center"
                width="100vw"
                height="100vh"
                position="fixed"
                top={0}
                left={0}
              >
                <MDTypography>Error Occured</MDTypography>
              </MDBox>
            ) : (
              <MDBox
                display="flex"
                justifyContent="center"
                alignItems="center"
                width="100vw"
                height="100vh"
                position="fixed"
                top={0}
                left={0}
              >
                <CircularProgress sx={{ color: "orange" }} size={54} />
              </MDBox>
            )}
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default HobbyTable;
